import { useFilterConfig } from '../hooks/useFilterConfig';
import { SelectFilter } from './reusableFilters/SelectFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AgentFilterControls() {
  const {
    AGENT_TYPE,
    AGENT_TEAM
  } = useFilterConfig();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectFilter, {
      filter: AGENT_TYPE
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: AGENT_TEAM,
      multi: true
    })]
  });
}